const API = require('#utils/api')
const { Snackbar } = require('#components/snackbar')
const { EmailVerificationPrompt } = require('#components/email-verification-prompt')
const { SiteHeader } = require('#components/site-header')

const HashParams = require('#utils/hash-params')

function PageBase({
  $window,
  $location,
  config,
  sync,
  requireLoggedIn = true,
  handleAccountRefresh = () => {},
}) {
  const APIEndpoint = API({
    $window,
    $location,
    apiRoot: config.apiRoot,
    sync,
  })
  const getAccountDetails = APIEndpoint.get('/accounts/details')

  const snackbar = Snackbar({ $window, sync })
  const emailVerificationPrompt = EmailVerificationPrompt({
    APIEndpoint,
    refreshAccountDetails,
  })
  const siteHeader = SiteHeader({
    $window,
    sync,
    APIEndpoint,
    refreshAccountDetails,
  })

  refreshAccountDetails()

  return {
    $window,
    $location,
    config,
    hashParams: HashParams({ $window, $location }),
    sync,
    APIEndpoint,
    refreshAccountDetails,
    components: {
      siteHeader,
      snackbar,
      emailVerificationPrompt,
    }
  }

  function _handleAccountRefresh(account) {
    siteHeader.handleAccountRefresh(account)
    emailVerificationPrompt.handleAccountRefresh(account)
    handleAccountRefresh(account)
  }

  function refreshAccountDetails() {
    return getAccountDetails({}, {
      redirectOn401: requireLoggedIn,
    })
      .then(res => {
        _handleAccountRefresh(res.body)
        return res
      })
      .catch(res => {
        if (res.status === 401) {
          _handleAccountRefresh(null)
        } else {
          throw res
        }
      })
  }
}

Object.assign(exports, { PageBase })
